import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { parsePromotableCatalog } from "./parsePromotableCatalog";
import type { PromotableCatalog } from "./types";

export const PROMOTABLE_SERVICES_QUERY_KEY = [
  "regulator-portal",
  "promotable-services",
] as const;

export const fetchPromotableServices =
  async (): Promise<PromotableCatalog | null> => {
    const response = await createRegulatorPortalInstance().get(
      API_ROUTES.REGULATOR_COMPLIANCE_PROMOTABLE_SERVICES,
    );
    return parsePromotableCatalog(response.data);
  };

export const usePromotableServices = (): UseQueryResult<
  PromotableCatalog | null,
  Error
> =>
  useQuery<PromotableCatalog | null, Error>({
    queryKey: PROMOTABLE_SERVICES_QUERY_KEY,
    queryFn: fetchPromotableServices,
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
    retry: false,
  });
